/**
 * @file
 * Dropdown toggle.
 */

((Choices, options) => {
  /**
   * Toggles content item.
   *
   * @param {Number} id
   *   The item id to be toggled.
   * @param {Element} toggleContent
   *   The toggle content element.
   */
  function toggleContentItem(id, toggleContent) {
    const isExpanded = toggleContent.classList.contains("is-expanded");
    const shouldExpand = id !== 1 && !isExpanded;
    const shouldContract = id === 1 && isExpanded;

    if (shouldExpand) {
      toggleContent.classList.add("is-expanded");
    }

    if (shouldContract) {
      toggleContent.classList.remove("is-expanded");
    }

    const active = toggleContent.querySelector(
      ".js-dropdown-toggle__item.is-expanded"
    );

    if (!active && id === 1) {
      return;
    }

    if (active) {
      if (id === 1) {
        active.classList.remove("is-expanded");
        return;
      }
      if (Number(active.dataset.id) === id) {
        return;
      }
      active.classList.remove("is-expanded");
    }

    const item = toggleContent.querySelector(
      `.js-dropdown-toggle__item[data-id="${id}"]`
    );
    item.classList.add("is-expanded");
  }

  /**
   * Initializes the dropdown toggles.
   */
  function init() {
    const dropdownToggles = document.querySelectorAll(".js-dropdown-toggle");

    dropdownToggles.forEach((dropdownToggle) => {
      const dropdown = dropdownToggle.querySelector(".js-dropdown select");

      const toggleContent = dropdownToggle.querySelector(
        ".js-dropdown-toggle__content"
      );

      const instance = new Choices(dropdown, options);

      instance.passedElement.element.addEventListener(
        "choice",
        (event) => {
          const { id } = event.detail.choice;
          toggleContentItem(id, toggleContent);
        },
        false
      );
    });
  }

  init();
})(window.Choices, window.dropdownOptions);
